interface WorkspaceBenchmarkPreference {
  workspace_id: string;
  contribute_budget_benchmarks?: boolean;
}

export function resolveWorkspaceBudgetBenchmarksEnabled(
  workspaceId: string | null | undefined,
  workspaces: WorkspaceBenchmarkPreference[] | undefined
): boolean {
  if (!workspaceId || !workspaces?.length) {
    return true;
  }

  const workspace = workspaces.find((entry) => String(entry.workspace_id) === String(workspaceId));
  return workspace?.contribute_budget_benchmarks ?? true;
}
